import * as tslib_1 from "tslib";
import { listApi } from "../../../../../../api";
import { DataItemType } from "../../../../../../form/schema";
import { RelevanceFormControl } from "../../../../../../form/src/common/controls/relevance-form-control";
import { Icon, Input, 
// TreeSelect,
Modal, Spin, Tooltip } from "@h3/antd-vue";
import { cloneDeep } from "lodash-es";
import { Component, Prop, Provide, Watch } from "vue-property-decorator";
let RelevanceFormModal = class RelevanceFormModal extends RelevanceFormControl {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.selected = new Array();
        this.selectedNew = new Array();
        this.allSelect = new Array();
        this.query = {};
        this.hover = false;
        this.full = false;
        this.newCol = [];
    }
    isMultiStatus() {
        return true;
    }
    clearSelected(val) {
        if (!val || (Array.isArray(val) && !val.length)) {
            this.selected = [];
        }
    }
    mounted() {
        if (this.ctrl.value && this.ctrl.value.id) {
            if (typeof this.ctrl.value.id === 'string') {
                let strArr = this.ctrl.value.id.split(';');
                this.selected = strArr.map((el, index) => {
                    let res = {
                        id: el
                    };
                    let showName = '';
                    if (this.ctrl.value.hasOwnProperty("showName")) {
                        showName = 'showName';
                    }
                    else if (this.ctrl.value.hasOwnProperty(this.getDisplayField)) {
                        showName = this.getDisplayField;
                    }
                    else if (this.ctrl.value.hasOwnProperty("name")) {
                        showName = 'name';
                    }
                    if (showName) {
                        res[showName + '_base'] = this.ctrl.value[showName].split(';')[index];
                    }
                    return res;
                });
            }
        }
    }
    get text() {
        let itemKey = this.getDisplayField;
        if (Array.isArray(this.ctrl.value) && this.ctrl.value.length > 0) {
            let s = "";
            this.ctrl.value.forEach((item) => {
                let val = item[itemKey];
                if (val === undefined) {
                    val = item[itemKey + '_base'];
                }
                if (val === undefined) {
                    val = item['name'];
                }
                let currentTitle = this.parseDisplayFieldValue(val, itemKey);
                s += currentTitle + ";";
            });
            s = s.substring(0, s.length - 1);
            return s;
        }
        else if (this.ctrl.value) {
            // 考虑到关联多选导入时没有传itemKey, 服务给出showName, 这种情况直接取showName
            let showName = '';
            if (this.ctrl.value.hasOwnProperty("showName")) {
                showName = this.ctrl.value["showName"];
            }
            else if (this.ctrl.value.hasOwnProperty(itemKey)) {
                showName = this.ctrl.value[itemKey];
            }
            else if (this.ctrl.value.hasOwnProperty("name")) {
                showName = this.ctrl.value["name"];
            }
            if (showName) {
                if (showName[showName.length - 1] === ';') {
                    showName = showName.substr(0, showName.length - 1);
                }
                let nameArr = showName.split(";");
                showName = nameArr.map((item) => (item ? item : "空")).join(";");
            }
            return showName;
        }
        else {
            return "";
        }
    }
    get dialogClass() {
        // { 'full-modal': full, 'relevance-form': true }
        if (this.full) {
            return 'full-modal relevance-form';
        }
        else {
            return 'relevance-form';
        }
    }
    onClick() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.query = this.getParams();
            let relevanceFormCode = this.control.parentKey
                ? `${this.control.parentKey}.${this.control.key}`
                : this.control.key;
            if (this.control.path) {
                relevanceFormCode = this.control.path.join(".");
            }
            if (this.control.options.showField &&
                Array.isArray(this.control.options.showField) &&
                this.control.options.showField.length > 0) {
                const param = {
                    sheetCode: this.control.options.sheetParams.sheetCode,
                    schemaCode: this.control.options.sheetParams.schemaCode,
                    relevanceFormCode: relevanceFormCode,
                };
                const res = yield listApi.selectFormTitle(param);
                if (res.errcode === 0) {
                    res.data.configBizPropertyList.map((options) => {
                        options.code = options.code === "id" ? "ids" : options.code;
                        options.propertyCode = options.code;
                        options.width = "120";
                        options.childColumns =
                            options.subSchema && options.subSchema.properties;
                        if (options.propertyType === DataItemType.Sheet &&
                            options.childColumns) {
                            options.childColumns = options.childColumns.map((v) => {
                                v.propertyCode = v.code;
                                v.vcTitle = v.name;
                                v.width = "150";
                                return v;
                            });
                        }
                        return options;
                    });
                    this.newCol = res.data.configBizPropertyList;
                    this.visible = true;
                    this.formTitleObj = yield RelevanceFormControl.service.getBizmodelTitle(this.controlOpts.schemaCode || "");
                }
            }
            else {
                this.visible = true;
            }
        });
    }
    onMouseenter() {
        this.hover = true;
    }
    onMouseleave() {
        this.hover = false;
    }
    clear() {
        this.ctrl.value = null;
        this.selected = [];
        this.selectedNew = [];
    }
    onListChange(rows) {
        this.selected = rows;
        const data = cloneDeep(rows);
        data.forEach((o) => {
            for (let key in o) {
                if (Array.isArray(o[key])) {
                    var i = o[key].length;
                    while (i--) {
                        if (o[key][i].checked === false) {
                            o[key].splice(i, 1);
                        }
                    }
                }
            }
        });
        this.selectedNew = data;
    }
    fullScreen(full) {
        this.full = full;
        try {
            if (full) {
                // @ts-ignore
                window.parent.window.document.querySelector('.icon-close').style.display = 'none';
            }
            else {
                // @ts-ignore
                window.parent.window.document.querySelector('.icon-close').style.display = 'block';
            }
        }
        catch (error) { }
    }
    onModalOk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.allSelect = cloneDeep(this.selected);
            let item = yield this.convertForMappings(this.allSelect);
            this.visible = false;
            if (item) {
                this.interceptorValue(item);
                setTimeout(() => {
                    this.setValue(cloneDeep(item));
                }, 300);
            }
            // this.interceptorValue(item);
            // this.setValue(item);
            // setTimeout(() => {
            //   this.setValue(deepCopy(item));
            // }, 500);
        });
    }
    onModalCancel() {
        this.visible = false;
        this.full = false;
        this.fullScreen(false);
        if (this.allSelect) {
            this.selected = this.allSelect;
        }
        else {
            this.selected = [];
        }
        if (this.ctrl.value) {
            // this.selected = this.ctrl.value;
        }
    }
    get isAuthorize() {
        return this.control.options.isAuthorize;
    }
    beforeCreate() {
        const comp = RelevanceFormControl.loadListSelector();
        this.$options.components.ListSelector = comp;
    }
};
tslib_1.__decorate([
    Prop({
        default: {}
    })
], RelevanceFormModal.prototype, "control", void 0);
tslib_1.__decorate([
    Provide()
], RelevanceFormModal.prototype, "isMultiStatus", null);
tslib_1.__decorate([
    Watch("ctrl.value")
], RelevanceFormModal.prototype, "clearSelected", null);
RelevanceFormModal = tslib_1.__decorate([
    Component({
        name: "relevance-form-modal",
        components: {
            ATooltip: Tooltip,
            AModal: Modal,
            AInput: Input,
            AIcon: Icon,
            ASpin: Spin,
        },
    })
], RelevanceFormModal);
export default RelevanceFormModal;
